import {styled, Typography, TypographyProps} from "@mui/material";

const StyledSpecialityPlaceCount = styled(Typography)<TypographyProps>(({theme}) => ({
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.secondary
}))

export default StyledSpecialityPlaceCount;
